const currencyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const numberFmt = new Intl.NumberFormat('en-US');

const percentFmt = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

export function formatCurrency(value: unknown): string {
  if (value == null) return '-';
  const num = typeof value === 'number' ? value : parseFloat(String(value));
  if (isNaN(num)) return '-';
  return currencyFmt.format(num);
}

export function formatNumber(value: unknown): string {
  if (value == null) return '-';
  const num = typeof value === 'number' ? value : parseFloat(String(value));
  if (isNaN(num)) return '-';
  return numberFmt.format(num);
}

export function formatPercent(value: unknown): string {
  if (value == null) return '-';
  const num = typeof value === 'number' ? value : parseFloat(String(value));
  if (isNaN(num)) return '-';
  return percentFmt.format(num / 100);
}

export function formatDate(value: unknown): string {
  if (value == null) return '-';
  const str = String(value);
  if (!str) return '-';
  try {
    const date = new Date(str);
    if (isNaN(date.getTime())) return str;
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  } catch {
    return str;
  }
}

export function formatDateTime(value: unknown): string {
  if (value == null) return '-';
  const str = String(value);
  if (!str) return '-';
  try {
    const date = new Date(str);
    if (isNaN(date.getTime())) return str;
    return date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return str;
  }
}

export function formatBoolean(value: unknown): string {
  if (value == null) return '-';
  return value === true || value === 'true' ? 'Yes' : 'No';
}

/** Auto-format a cell value based on Salesforce field type */
export function formatFieldValue(value: unknown, fieldType?: string): string {
  if (value == null) return '-';

  switch (fieldType) {
    case 'currency':
      return formatCurrency(value);
    case 'percent':
      return formatPercent(value);
    case 'double':
    case 'int':
    case 'integer':
      return formatNumber(value);
    case 'date':
      return formatDate(value);
    case 'datetime':
      return formatDateTime(value);
    case 'boolean':
      return formatBoolean(value);
    case 'url':
      return String(value);
    default:
      return String(value);
  }
}
